import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SiaHttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root',
})
export class SiaSelectBoxDataApi {
  private http = inject(SiaHttpService);

  private readonly apiController: string = 'widgetdata';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() { }

  loadFullData(
    key: any,
    foreignKey: any,
    order: boolean,
    selectable: boolean = false,
    connectionStringName?: string
  ): Promise<any> {
    let params = new HttpParams();
    params = params.set('kvp', `${key}`);
    if (foreignKey) {
      params = params.set('foreignKey', JSON.stringify(foreignKey));
    }
    params = params.set('order', `${order}`);
    params = params.set('selectable', `${selectable}`);
    if (connectionStringName) {
      params = params.set('connectionStringName', `${connectionStringName}`);
    }

    let options = { params };

    return this.http
      .get(`${this.apiController}/fullkvp`, options)
      .then((data) => {
        return data;
      });
  }

  loadRadarData(
    key: any,
    value: any,
    foreignKey: string,
    order: boolean = true,
    selectable: boolean = false,
  ): Promise<any> {
    let params = new HttpParams();
    params = params.set('kvp', `${key}`);
    if (foreignKey) {
      params = params.set('foreignKey', `${foreignKey}`);
    }
    params = params.set('order', `${order}`);
    params = params.set('selectable', `${selectable}`);
    if (value) {
      params = params.set('value', `${value}`);
    }
    let options = { params };
    return this.http
      .get(`${this.apiController}/radarkvp`, options)
      .then((data) => {
        return data;
      });
  }
}
